import { render, staticRenderFns } from "./SwitchAppointment.vue?vue&type=template&id=71b30423&"
import script from "./SwitchAppointment.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SwitchAppointment.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71b30423')) {
      api.createRecord('71b30423', component.options)
    } else {
      api.reload('71b30423', component.options)
    }
    module.hot.accept("./SwitchAppointment.vue?vue&type=template&id=71b30423&", function () {
      api.rerender('71b30423', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/lpu/components/LpuFilters/components/SwitchAppointment/SwitchAppointment.vue"
export default component.exports